import { useState } from 'react';
import { Check, Copy, ExternalLink, Gift } from 'lucide-react';

const couponCode = 'REGALONUMERATHUMPAREJAS';

export default function GiftCouponCard() {
  const [copyStatus, setCopyStatus] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(couponCode);
      setCopyStatus('copied');
    } catch {
      setCopyStatus('manual');
    }
  };

  return <section aria-labelledby="gift-coupon-title" className="mb-6 rounded-2xl border border-[#d4af37]/60 bg-white p-5 sm:p-8 shadow-sm">
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
      <div className="min-w-0">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-morado"><Gift size={18} aria-hidden="true" /> Un regalo para ti</p>
        <h2 id="gift-coupon-title" className="mt-3 text-2xl font-bold text-morado">Numerología en el amor</h2>
        <p className="mt-2 text-sm text-gray-600">Tienes un <strong className="font-semibold text-morado">cupón del 100% de descuento</strong> para este producto: un reporte de numerología de pareja generado por IA. Usa el siguiente código en la tienda:</p>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <code className="max-w-full break-all select-all rounded-xl border border-[#d4af37]/40 bg-[#d4af37]/10 px-4 py-3 font-mono text-sm sm:text-base font-semibold text-morado">{couponCode}</code>
          <button type="button" onClick={copy} className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-morado hover:bg-morado/5">
            {copyStatus === 'copied' ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
            {copyStatus === 'copied' ? 'Código copiado' : 'Copiar código'}
          </button>
        </div>
        <p role="status" className="mt-2 text-xs text-gray-500">{copyStatus === 'manual' ? 'Selecciona y copia el código para usarlo en la tienda.' : copyStatus === 'copied' ? 'El código está listo para pegarse en la tienda.' : ''}</p>
      </div>
      <a href="https://tienda.numerologia-cotidiana.com/productos/numerologia-en-el-amor" target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-5 py-3 text-sm font-semibold text-morado hover:bg-[#d4af37]/90 transition-colors">
        Ver producto <ExternalLink size={16} aria-hidden="true" />
      </a>
    </div>
  </section>;
}
